import { createSelector } from 'reselect';

const publicFilesReducer = (state) => state.get('publicFilesReducer');

export const loadingSelector = createSelector(publicFilesReducer, (state) =>
  state.get('loading'),
);

export const errorSelector = createSelector(publicFilesReducer, (state) =>
  state.get('error'),
);

export const publicFilesUrlsSelector = createSelector(
  publicFilesReducer,
  (state) => state.get('publicFilesUrls').toJS(),
);
